import { Button, Textarea } from "@aircall/ds";
import { useTranslation } from "react-i18next";

import { SubmitButton } from "@/components/SubmitButton/SubmitButton";

import { useEvaluationUpdateForm } from "@/hooks/useEvaluationUpdateForm/useEvaluationUpdateForm";
import { useEvaluationUpdateFormInteractions } from "@/hooks/useEvaluationUpdateFormActions/useEvaluationUpdateFormActions";
import { EvaluationFormFooterProps } from "./EvaluationUpdateFormFooter.decl";

export function EvaluationUpdateFormFooter({
  onClickCancel,
  loading,
}: Readonly<EvaluationFormFooterProps>) {
  const { t } = useTranslation();

  const { form } = useEvaluationUpdateForm();

  const { hasUnansweredQuestions, overallMaxScore, overallScore } =
    useEvaluationUpdateFormInteractions();

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-col gap-3 p-4">
        <div className="flex items-center justify-between">
          <p className="text-base font-bold">{t("evaluation.overall_title")}</p>
          <p className="text-xs font-normal">
            {t("evaluation.overall_score", {
              score: overallScore,
              maxScore: overallMaxScore,
            })}
          </p>
        </div>
        <div className="flex flex-col gap-4">
          <form.Field name="feedback">
            {(field) => (
              <Textarea
                data-test="evaluation-global-feedback"
                value={field.state.value}
                onChange={(event) => {
                  field.handleChange(event.target.value);
                }}
                placeholder={t("evaluation.add_feedback")}
              />
            )}
          </form.Field>
          <div className="flex justify-end gap-2">
            <Button
              onClick={onClickCancel}
              variant="ghost"
              size="lg"
              data-test="evaluation-cancel-button"
            >
              {t("cancel")}
            </Button>
            <SubmitButton
              data-test="evaluation-submit-button"
              type="submit"
              loading={loading}
              disabled={hasUnansweredQuestions > 0}
              size="lg"
            >
              {t("update")}
            </SubmitButton>
          </div>
        </div>
      </div>
    </div>
  );
}
